<template>
  <div
    :class="!isLargeScreen ? 'reading-section' : 'note-book'"
  >
    <div class="line" />
    <template v-for="(item, i) in items">
      <p>
        {{ i }}: {{ item.text }}
      </p>
    </template>
  </div>
</template>

<script>
export default {
  name: 'Question',
  data: () => ({
    drawer: null,
    items: [
      { text: '主持人的全名(正确拼写)是什么?' },
      { text: 'Refactoring UI的作者是谁(不只一个人)?' },
      { text: 'Refactoring UI的价格是多少?' },
      { text: '这期的嘉宾还参加过fullstack radio的哪期节目?' },
      { text: '接上题, 那期的节目主题是什么，节目日期是哪天?' },
      { text: '嘉宾刚开始接触到 active record 概念是用的什么框架?' },
      { text: '①嘉宾认为太多的工作放在代码，相比放在数据库完成 容易遇到哪些问题?' },
      { text: 'Plus one issues 是多少?' },
      { text: '嘉宾做哪个项目的时候意识到了问题①（上上个问题）中提到的问题?' },
      { text: '请用UML（建议plantuml）用例图，说明嘉宾项目。' },
      { text: '嘉宾项目开始阶段遇到了什么问题?' },
      { text: '嘉宾为了解决上面的问题，在没有尝试pushing more work to database之前 使用了什么思路来解决?' },
      { text: '上题中使用的思路带来了什么负作用?' },
      { text: '在嘉宾技术栈中just creating the scope， scope是个什么样的技术，有什么好处?' },
      { text: '既然嘉宾的这个项目他最后认为pushing more work to database是个好主意，是什么项目特性让嘉宾一开始靠直觉不会使用数据库解决这个思路?' },
      { text: '如果我们要监控我们的广播网站https://huanle0610.gitlab.io是否正常，我可用使用该期节目哪家赞助商， 第一个月我们要付多少钱?' },
      { text: '你是我们网站的负责人，半夜2：00我们广播网站挂了， 你会收到什么形式的通知?' },
      { text: '嘉宾项目中使用了什么数据库， 他认为该数据库的什么特性让其非常适合在该项目中应用?' },
      { text: 'where not exists是个什么技术，应用于什么场景，好处是什么?' },
      { text: '嘉宾什么时候开始对where not exists深刻认识的?' },
      { text: '嘉宾的项目中where not exists应用于什么场景?' },
      { text: '节目中嘉宾提到项目中blacklists是用来拦截用户多次密码尝试问题，（分号问号） 错误尝试几次会进入blacklists？' },
      { text: 'eager load是什么？' },
      { text: '嘉宾在节目中提到他有一段fifty minute talk，这次talk的演讲主题什么，发生在什么时候？' },
      { text: '请点评节目赞助商产品优点？' },
      { text: '请指出我们手头文本翻译错误35处（跳过会议讨论过的）？' },
    ],
  }),
  computed: {
    isLargeScreen() {
      let type = true;
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          type = false;
          break;
        case 'md':
        case 'lg':
        case 'xl':
        default:
          type = true;
      }

      return type;
    },
  },
};
</script>

<style scoped>
  .note-book {
    position: relative;
    background: #fffcce;
    width: 100%;
  }

  .note-book .line {
    position: absolute;
    left: 1.5em;
    width: 1.3em;
    height: 100%;
    border-right: .1em solid #ffced1;
  }

  .note-book .line:after {
    content: '';
    border-right: 2px solid #ffced1;
    width: 20px;
    height: 100%;
    left: 10px;
    position: absolute;
  }

  .note-book p {
    line-height: 3em;
    height: 3em;
    text-indent: 4em;
    border-bottom: 0.2em solid #dddddd;
  }

  .reading-section {
    background-color: #f7f3de;
    word-wrap: break-word;
    word-break: break-word;
  }
  .reading-section .line{
    display: none;
  }

  .reading-section p {
    color: #333;
    margin: 0 20px 0;
    line-height: 1.6;
    text-indent: .1em;
    text-align: justify;
  }

</style>
